import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { AcademicGroupType, CreateAcademicGroupTypePayload } from "../types";

export const fetchGroupTypes = async (): Promise<AcademicGroupType[]> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.ACADEMIC_GROUP_TYPES.LIST);
  return data.groupTypes ?? data;
};

export const createGroupType = async (
  payload: CreateAcademicGroupTypePayload
): Promise<AcademicGroupType> => {
  const { data } = await privateClient.post(
    SUPER_ADMIN_ENDPOINTS.ACADEMIC_GROUP_TYPES.CREATE,
    payload
  );
  return data.groupType ?? data;
};